function Calendar() {
    return (
        <div>
            <h2>Calendar</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default Calendar;